import { render, staticRenderFns } from "./certificateConfig.vue?vue&type=template&id=68566ca5&scoped=true&"
import script from "./certificateConfig.vue?vue&type=script&lang=js&"
export * from "./certificateConfig.vue?vue&type=script&lang=js&"
import style0 from "./certificateConfig.vue?vue&type=style&index=0&id=68566ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68566ca5",
  null
  
)

export default component.exports